import { CartesianChart, type CartesianChartProps } from './CartesianChart';

export type AreaChartProps = Omit<CartesianChartProps, 'marks'>;

/** Monotone line with a translucent fill down to the zero baseline. */
export const AreaChart = (props: AreaChartProps) => <CartesianChart {...props} marks='area' />;

AreaChart.displayName = 'AreaChart';
